<template>
  <div class="section">
    <Breadcrumb>
      <router-link to="/">Startseite</router-link>
      <router-link to="/services">Services</router-link>
      <router-link :to="`/services/100`"><Icon icon="computer" />Antrag auf Ausbildungsförderung</router-link>
      <router-link to="/services/100/section-5">Zusammenfassung & Antrag überarbeiten</router-link>
    </Breadcrumb>
    <div class="section__header">
      <div class="headline-link wrapper">
        <div class="headline-link__headline">
          <router-link to="/services/100" class="back-button"><Icon icon="arrowLeft" /></router-link>
          <Icon icon="checkAntrag" color="detailed" class="hide-mobile"/>
          <Headline subline="Abschluss" headline="Zusammenfassung & Antrag überarbeiten" />
        </div>
        <div class="headline-link__right hide-mobile">
          <div>
            <h3><b>00</b> / 02</h3>
            <div class="progress" title="Fortschritt">
              <div class="bar" style="width: 0%;"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="section__content wrapper margin-bottom--90 margin-top--40">
      <div class="row between-xs top-xs">
        <div class="section__content__left col-xs-12 col-md-8">

<!-- Zusammenfassung -->
          <h3 class="margin-bottom--20">1. Zusammenfassung</h3>
          <div class="greenline margin-bottom--30"></div>

          <div class="summary" title="Abschnitt bearbeiten">
          <router-link to="/services/100/section-1" class="summary__top">
            <Icon icon="personalData" color="detailed" />
            <div class="text">
              <h5>Abschnitt 1</h5>
              <h3 class="margin-bottom--10">Personenbezogene Angaben</h3>
              <p>Alle Pflichtangaben ausgefüllt.</p>
            </div>
            <div class="donut donut--done" title="Antrag vollständig">
              <img src="../../assets/images/donutFull.svg" alt="Fortschritt">
              <img src="../../assets/images/icons/check--blue.svg">
            </div>
            <Icon icon="arrowRight" class="arrow hide-mobile"/>
          </router-link>
        </div>

        <div class="summary" title="Abschnitt bearbeiten">
          <router-link to="/services/100/section-2" class="summary__top">
            <Icon icon="education" color="detailed" />
            <div class="text">
              <h5>Abschnitt 2</h5>
              <h3 class="margin-bottom--10">Schulischer & beruflicher Werdegang</h3>
              <p>Alle Pflichtangaben ausgefüllt.</p>
            </div>
            <div class="donut donut--done" title="Antrag vollständig">
              <img src="../../assets/images/donutFull.svg" alt="Fortschritt">
              <img src="../../assets/images/icons/check--blue.svg">
            </div>
            <Icon icon="arrowRight" class="arrow hide-mobile"/>
          </router-link>
        </div>

        <div class="summary" title="Abschnitt bearbeiten">
          <router-link to="/services/100/section-3" class="summary__top">
            <Icon icon="finance" color="detailed" />
            <div class="text">
              <h5>Abschnitt 3</h5>
              <h3 class="margin-bottom--10">Eigenes Einkommen & Vermögen</h3>
              <p class="error"><b>2</b> fehlende Pflichtangaben / <b>4</b> fehlerhafte Angaben.</p>
            </div>
            <div class="donut" title="Bereits ausgefüllte Formular-Gruppen">
              <img src="../../assets/images/donut5.svg" alt="Fortschritt">
              <p><b>4 </b>/ 7</p>
            </div>
            <Icon icon="arrowRight" class="arrow hide-mobile"/>
          </router-link>
        </div>

        <div class="summary" title="Abschnitt bearbeiten">
          <router-link to="/services/100/section-4" class="summary__top">
            <Icon icon="parents" color="detailed" />
            <div class="text">
              <h5>Abschnitt 4</h5>
              <h3 class="margin-bottom--10">Angaben der Eltern / Ehe-/Lebenspartner</h3>
              <p class="error"><b>4</b> fehlende Pflichtangaben.</p>
            </div>
            <div class="donut" title="Bereits ausgefüllte Formular-Gruppen">
              <img src="../../assets/images/donut5.svg" alt="Fortschritt">
              <p><b>4 </b>/ 7</p>
            </div>
            <Icon icon="arrowRight" class="arrow hide-mobile"/>
          </router-link>
        </div>

<!-- Angaben des Ehe-/Lebenspartners -->
        <h3 class="margin-bottom--20 margin-top--60">2. Antrag übertragen</h3>
        <div class="greenline margin-bottom--30"></div>
        <div class="field">
          <div class="row">
            <div class="col-xs-12 label-hint">
              <h6>Einverständnis & Unterschrift</h6>
              <div class="hint">
                <Icon icon="hint" />
                <div class="hint__tooltip">
                  <h6>Hinweis</h6>
                  <p class="margin-bottom--20">Hallo hallo</p>
                  <h6>Warum ist das wichtig?</h6>
                  <p>Hallo hallo</p>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-12">
              <p>Mir ist bekannt,</p>
              <ul class="margin-bottom--30">
                <li>dass falsche oder unvollständige Angaben oder die Unterlassung von Änderungsanzeigen strafrechtlich verfolgt oder als Ordnungswidrigkeit mit einer Geldbuße geahndet werden können und dass zu Unrecht gezahlte Beträge zurückgefordert werden;</li>
                <li>dass ich verpflichtet bin, jede Änderung meiner wirtschaftlichen Lage (z. B. des von mir erzielten Einkommens) sowie der Familien- und Ausbildungsverhältnisse (auch der Geschwister), über die im Rahmen dieses Antrags Erklärungen abgegeben worden sind, unverzüglich dem Amt für Ausbildungsförderung schriftlich mitzuteilen;</li>
                <li>dass die im Rahmen dieses Antrags gemachten Angaben zu meinem Einkommen beim zuständigen Sozialleistungsträger, beim Finanzamt und bei meinem Arbeitgeber durch eine Kontenabfrage nach § 93 Abs. 8 Abgabenordnung (AO) beim Bundeszentralamt für Steuern überprüft werden können, wenn die Voraussetzungen vorliegen;</li>
                <li>dass Vermögenswerte auch dann meinem Vermögen zuzurechnen sind, wenn ich diese rechtsmissbräuchlich übertragen habe. Dies ist der Fall, wenn ich in zeitlichem Zusammenhang mit der Aufnahme der förderungsfähigen Ausbildung bzw. der Stellung des Antrags auf Ausbildungsförderung oder während der förderungsfähigen Ausbildung Teile meines Vermögens unentgeltlich oder ohne gleichwertige Gegenleistung an Dritte, insbesondere an meine Eltern oder andere Verwandte, übertragen habe;</li>
                <li>dass die im Rahmen dieses Antrags gemachten Angaben zu meinem Vermögen durch einen Datenabgleich (§ 41 Abs. 4 BAföG i.V.m. § 45d EStG) und durch eine Kontenabfrage nach § 93 Abs. 8 Abgabenordnung (AO) beim Bundeszentralamt für Steuern überprüft werden können, wenn die Voraussetzungen vorliegen.</li>
                <li>dass im Fall der Inanspruchnahme von Ausbildungsförderung in Form eines verzinslichen Bankdarlehens der Kreditanstalt für Wiederaufbau (KfW) die für die Darlehensrückerstattung erforderlichen Daten zwischen der KfW und dem Bundesverwaltungsamt ausgetauscht werden und dass die KfW die Auszahlungsdaten dem zuständigen Amt für Ausbildungsförderung übermittelt.</li>
              </ul>
              <p>Ich bestätige, dass ich die Erläuterungen zum Antrag auf Ausbildungsförderung sowie die <u>Hinweise zum Datenschutz</u> zur Kenntnis genommen habe.
                Ich versichere, dass meine Angaben richtig und vollständig sind und im amtlichen Formblatt keine Änderungen vorgenommen wurden.</p>
            </div>
          </div>
          <div class="divider margin-top--30 margin-bottom--30"></div>
          <div class="row">
            <div class="col-xs-12 col-md-3">
              <p class="margin-bottom--10">Datum:</p>
              <h6>08.02.2019</h6>
            </div>
            <div class="col-xs-12 col-md-9">
              <p class="margin-bottom--10">Unterschrift:</p>
              <div class="signature">
                <Icon icon="signature" color="detailed" />
                <div class="signature__text">
                  <h6 v-if="activeUser">{{activeUser.firstName}} {{activeUser.lastName}}</h6>
                  <h6 v-else>Ihre Unterschrift</h6>
                  <p v-if="activeUser">Dieser Antrag wird mit Ihrer persönlichen digitalen Signatur aus dem Bürgerkonto unterschrieben.</p>
                  <p v-else>Sie können diesen Antrag mit Ihrer persönlichen Signatur digital unterschreiben. Dazu müssen Sie sich in Ihr Bürgerkonto einloggen.</p>
                </div>
              </div>
            </div>
          </div>
          <div class="row margin-top--40">
            <div class="col-xs-12 label-hint">
              <h6>Antrag digital übertragen</h6>
              <div class="hint">
                <Icon icon="hint" />
                <div class="hint__tooltip">
                  <h6>Hinweis</h6>
                  <p class="margin-bottom--20">Hallo hallo</p>
                  <h6>Warum ist das wichtig?</h6>
                  <p>Hallo hallo</p>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-12">
              <p class="margin-bottom--20">Der Antrag, mit allen von Ihnen beigefügten Nachweisen und Dokumenten, wird sicher verschlüsselt an die Server der Verwaltung übertragen. Der Schutz Ihrer persönlichen Daten ist uns besonders wichtig. Ihre Daten werden niemals an Dritte weitergegeben. Mehr zu unseren Datenschutzbestimmungen lesen Sie <u>hier</u>.</p>
            </div>
            <div class="col-xs-12">
              <Button type="primary" @click.native="toggleAuthModal" text="Authentifizieren & Antrag übertragen" />
            </div>
          </div>
        </div>


        </div>
        
        <!-- auth-Modal -->
        <Modal v-if="showAuthModal" @closeModal="toggleAuthModal">
          <Card padding="45px" class="modal-auth">
            <Auth :serviceId="100"/>
          </Card>           
        </Modal>

        <!-- Sidebar -->
        <div class="section__content__sidebar col-xs-12 col-md-3">
          <div class="nav-element error"
            @click="activeField = 1"
            :class="{'selected' : activeField == 1}"
            >
            <p>1. Zusammenfassung</p>
            <div class="status"></div>
          </div>
          <div class="nav-element"
            @click="activeField = 2"
            :class="{'selected' : activeField == 2}"
            >
            <p>2. Antrag übertragen</p>
            <div class="status"></div>
          </div>
        </div>
      </div>
    </div>

    <div class="teaser">
      <div class="wrapper">
        <div class="row between-xs">
          <div class="col-xs-12 col-md-8">
            <router-link to="/services/100/section-3">
              <Button type="secondary" text="Vorheriger Abschnitt"/>
            </router-link>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Headline from '../../components/Headline/Headline';
import Breadcrumb from '../../components/Breadcrumb/Breadcrumb';
import Icon from '../../components/Icon/Icon';
import Card from '../../components/Card/Card';
import Toggle from '../../components/formElements/Toggle/Toggle';
import Teaser from '../../components/Teaser/Teaser';
import Button from '../../components/Button/Button';
import Modal from '../../components/Modal/Modal';
import Auth from '../../components/Auth/Auth';
import InputText from '../../components/formElements/InputText/InputText';
import InputSelect from '../../components/formElements/InputSelect/InputSelect';
import InputAutocomplete from '../../components/formElements/InputAutocomplete/InputAutocomplete';


export default {
  name: 'Section1',
  components: {
    Headline,
    Breadcrumb,
    Icon,
    Card,
    Toggle,
    Teaser,
    Button,
    Modal,
    Auth,
    InputText,
    InputAutocomplete,
    InputSelect,
  },
  data() {
    return {
      showModal: false,
      showAuthModal: false,
      activeField: 1,
      toggleAll: false,
      time: '',
      home: false,
      insurance: false,
      baby: false
    };
  },
  computed: {
    ...mapGetters({
      activeUser: 'auth/getUserSession',

    }),
  },
  methods: {
    toggleModal() {
      this.showModal = !this.showModal;
    },
    toggleAuthModal() {
      this.showAuthModal = !this.showAuthModal;
    },
  },
  mounted() {
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style src="./Section.scss" lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Section/Section5.vue